import type { AppRoute } from "@iyk/react-router/client"
import {
  Link as RRLink,
  NavLink as RRNavLink,
  type LinkProps,
  type NavLinkProps,
} from "react-router"

export const AppLink = (props: AppLink.Props) => {
  return <RRLink viewTransition {...props} />
}

export const AppNavLink = (props: AppNavLink.Props) => {
  return <RRNavLink viewTransition {...props} />
}

export namespace AppLink {
  export type Props = Omit<LinkProps, "to"> & { to: AppRoute }
}

export namespace AppNavLink {
  export type Props = Omit<NavLinkProps, "to"> & { to: AppRoute }
}
